export default __webpack_public_path__ + "static/media/CAI.21b9491d.png";